<div style="width: 100%">
    <router-outlet></router-outlet>
</div>